/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { MDDEResult } from "@sa/rep-mdde";
import { useDictionary, useOLAPTransformer, yearToCropYearFull, OLAPTransformerResult } from "../../../shared";
import { dataService, dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import Highcharts, { SeriesOptionsType } from "highcharts";
import { useChartOptions } from "../../../../charts/useChartOptions";
import { legendPipe, chartPipe, tooltipPipe, addXAxisPipe } from "../../../../charts/pipes";

const CATEGORIES_AXIS = "calendar.default";
const SERIES_AXIS = "countries.default";

export function useData1(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [, categories] = useDictionary(dictionaryService, "calendar-stocktouseratio");
  const [, series] = useDictionary(dictionaryService, "countries-stocktouseratio");
  const options = useMemo(() => {
    if (!olapResult || !categories || !series) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsDictionaries: new Map([
        [CATEGORIES_AXIS, categories],
        [SERIES_AXIS, series],
      ]) as ReadonlyMap<string, Dictionary>
    }
  }, [olapResult, categories, series]);
  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${CATEGORIES_AXIS}.name`],
      rows: [`${SERIES_AXIS}.name`],
      cellData: {
        inCell: ["Measures.value"],
        attributes: [`${CATEGORIES_AXIS}.name`, `${SERIES_AXIS}.name`],
      },
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
